import React, {useEffect} from 'react';
import PeopleAltSharpIcon from "@material-ui/icons/PeopleAltSharp";
import DataTile from "../../metrics/DataTile";
import {useDispatch, useSelector} from "react-redux";
import testOKR from "./testOkr";

const TileAverageLoginsPaidCustomers= ({props})=> {

    const {users, loadingUsers, loadingUsersError,} = useSelector(({users}) => users);
    const {okr, loadingAdminOKR, loadingAdminOKRError}= useSelector(({admin})=>admin);
    // const okr = testOKR;
    // const loadingAdminOKR = false;
    // const loadingAdminOKRError = false;

    const valueFunction = ()=> {

        if(loadingAdminOKRError){
            return null
        } else {

            const engagementDetails = okr && okr.engagement_details;
            const paidEngagementDetails = engagementDetails && engagementDetails.paid;
            const paidCustomersArray = paidEngagementDetails && Object.values(paidEngagementDetails);

            const avgLoginsArray = paidCustomersArray
                && paidCustomersArray
                .filter((customer)=> customer.average_logins_30_days !== 0)
                .map((customer)=> customer.average_logins_30_days);

            let logins = 0;
            let engagedCustomers = avgLoginsArray && avgLoginsArray.length;

            avgLoginsArray && avgLoginsArray.forEach((item)=> {
                logins += item
                // return logins;
            })


            return (logins/engagedCustomers).toFixed(1);
        }

    }
    return(
        <DataTile
            color="primary"
            subTitle="Avg Logins for Engaged Customers"
            tipText={"OKR information is not available in the development server. Average Logins for customers marked as engaged."}
            icon={<PeopleAltSharpIcon style={{fontSize: "70px"}}/>}
            // stateFetchAction={fetchUsers()}
            valueFunction={()=> valueFunction ? valueFunction() : null}
        />
    )
}

export default TileAverageLoginsPaidCustomers